import React from 'react';

import PropTypes from 'prop-types';

import A from 'wanderu-component-react-router-link';
import {
    Section,
    Typography,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import styles from './CarrierLinkSection.scss';

const MINIMUM_LINKS = 3;

const carrierLinkSectionPropTypes = {
    namespace: PropTypes.string.isRequired,
    links: PropTypes.arrayOf(PropTypes.shape({
        averageDailyTrips: PropTypes.number,
        carrierName: PropTypes.string,
        carrierCode: PropTypes.string,
        minPrice: PropTypes.number,
        url: PropTypes.string,
    })).isRequired,
    transMode: PropTypes.string.isRequired,
};

function CarrierLinkSection(props) {
    const {
        t,
        i18nMoney,
        namespace,
        links,
        transMode,
        showAnchor,
    } = props;

    if (!links || links.length < MINIMUM_LINKS) {
        return null;
    }

    return (
        <Section aria-labelledby="carrier-link-section">
            <Typography
                component="h2"
                id="carrier-link-section"
                variant="h3"
            >
                {t(`${namespace}:carrierListTitle`)}
            </Typography>
            <ul className={styles.linkSection}>
                {links.map((link) => {
                    const {
                        carrierCode,
                        carrierName,
                        averageDailyTrips,
                        minPrice,
                        url,
                    } = link;

                    return (
                        <li key={carrierCode}>
                            <A
                                href={url}
                                variant="subdued"
                            >
                                {t(`${namespace}:carrierListItem`, {
                                    carrierName,
                                    averageDailyTrips: parseInt(averageDailyTrips, 10),
                                    minPrice: i18nMoney(Math.round(minPrice)).format({
                                        maximumFractionDigits: 0,
                                        minimumFractionDigits: 0,
                                    }),
                                    transModePlural: t.plural(`baseApp:${transMode}`, 2).toLowerCase(),
                                })}
                            </A>
                        </li>
                    );
                })}
            </ul>
            {showAnchor && (
                <A
                    href="#carrier-section"
                    native
                >
                    {t(`${namespace}:carrierListSeeMore`)}
                </A>
            )}
        </Section>
    );
}

CarrierLinkSection.propTypes = carrierLinkSectionPropTypes;

export { CarrierLinkSection };
export default localize(CarrierLinkSection);
